import { render } from "./ShoppingActivityList.vue?vue&type=template&id=e4958744&scoped=true"
import script from "./ShoppingActivityList.vue?vue&type=script&lang=js"
export * from "./ShoppingActivityList.vue?vue&type=script&lang=js"

import "./ShoppingActivityList.vue?vue&type=style&index=0&id=e4958744&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4958744"]])

export default __exports__